import { filter } from "lodash"

export default class CrudFiltering {

    constructor(name) {
        this.name = name
    }

    init(component) {
        this.vm = component
        this.restoreUiConfig()
    }

    listed() {
        this.saveUiConfig()
    }

    filteringValues(selectValues, withNone = false) {
        let values = Object.keys(selectValues).map(value => { 
            return {value, text: selectValues[value] }
        })
        .sort((a, b) => (a.text > b.text) ? 1 : -1)
        if (withNone) {
            values.unshift({text: this.vm.$t('common.none'), value: 'x'})
        }
        return values
    }

    filterChange(data) {
        let prop = Object.keys(data)[0]
        if (data[prop].length > 0) {
            this.vm.filters[prop] = data[prop]
        } else {
            delete this.vm.filters[prop]
        }
        this.vm.filters = {...this.vm.filters}    // Clone to force reactivity
        this.vm.reload()
    }

    sortChange(data) {
        if (data.order == null) {
            return
        }
        this.vm.ctrl.query.sort = [data.order == 'descending' ? '-' + data.prop : data.prop]
        this.vm.ctrl.reload()
    }

    clearFilters() {
        this.vm.$refs.table.clearFilter()
        this.vm.$refs.table.clearSort()
        this.vm.$refs.search.clearFilter()
        this.vm.filters = {}
        this.vm.search = ''
        this.vm.reload()
    }

    saveUiConfig() {
        let data = { 
            filters: this.vm.filters,
            paging: this.vm.ctrl.paging,
            sort: this.vm.ctrl.client.query.sort,
            // We don't store the full query to avoid issues when the code changes.
            //query: this.vm.ctrl.client.query,
        }
        this.vm.$auth.setUiConfig(data, this.name)
    }

    restoreUiConfig() {
        let config = this.vm.$auth.getUiConfig(this.name)
        if (config) {
            this.vm.filters = config.filters
            this.vm.ctrl.paging = config.paging

            /*
            // We don't restaure the full query because it is not stored anymore.
            this.vm.ctrl.query = config.query
            this.vm.ctrl.client.query = config.query
            */

            this.vm.ctrl.query.filters = this.vm.requestFilters()
            this.vm.ctrl.query.sort = config.sort ? config.sort : config.query.sort
            this.vm.ctrl.query.limit = config.paging.perPage
            this.vm.ctrl.query.skip = (config.paging.currentPage - 1) * config.paging.perPage

            this.vm.ctrl.client.query = this.vm.ctrl.query
        }
    }
}
